import { ArrowUpRight } from 'lucide-react'

interface ServiceCardProps {
  service: {
    id: string
    number: string
    title: string
    summary: string
    details: string[]
  }
  detailed?: boolean
}

export function ServiceCard({ service, detailed = false }: ServiceCardProps) {
  return (
    <article className={`service-card${detailed ? ' service-card--detailed' : ''}`} id={service.id}>
      <span className="service-card__number">{service.number}</span>
      <div>
        <h3>{service.title}</h3>
        <p>{service.summary}</p>
        {detailed ? (
          <ul className="check-list">
            {service.details.map((detail) => <li key={detail}>{detail}</li>)}
          </ul>
        ) : (
          <a className="text-link" href={`/services/#${service.id}`}>
            What’s included <ArrowUpRight aria-hidden="true" />
          </a>
        )}
      </div>
    </article>
  )
}
